module.exports = __webpack_public_path__ + "static/media/croft-imagelist.2927ba0b.jpg";